/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M10 17L18 17M10 12L18 12M10 7H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7 7V7.5H6V7M7 7V6.5H6V7M7 7H6M7 12V12.5H6V12M7 12V11.5H6V12M7 12H6M7 17V17.5H6V17M7 17V16.5H6V17M7 17H6M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M10 17L18 17M10 12L18 12M10 7H18M7 7V7.5H6V7M7 7V6.5H6V7M7 7H6M7 12V12.5H6V12M7 12V11.5H6V12M7 12H6M7 17V17.5H6V17M7 17V16.5H6V17M7 17H6M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25L14.75 1.25C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27434 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25L22.75 14.75L22.75 14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75L9.25 22.75C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75L1.25 9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27434 3.98005 1.79497ZM6 5.75C5.58579 5.75 5.25 6.08579 5.25 6.5L5.25 7L5.25 7.5C5.25 7.91422 5.58579 8.25 6 8.25L7 8.25C7.41421 8.25 7.75 7.91422 7.75 7.5L7.75 7L7.75 6.5C7.75 6.08579 7.41421 5.75 7 5.75L6 5.75ZM10 6.25C9.58579 6.25 9.25 6.58579 9.25 7C9.25 7.41422 9.58579 7.75 10 7.75L18 7.75C18.4142 7.75 18.75 7.41422 18.75 7C18.75 6.58579 18.4142 6.25 18 6.25L10 6.25ZM6 10.75C5.58579 10.75 5.25 11.0858 5.25 11.5L5.25 12L5.25 12.5C5.25 12.9142 5.58579 13.25 6 13.25L7 13.25C7.41421 13.25 7.75 12.9142 7.75 12.5L7.75 12L7.75 11.5C7.75 11.0858 7.41421 10.75 7 10.75L6 10.75ZM10 11.25C9.58579 11.25 9.25 11.5858 9.25 12C9.25 12.4142 9.58579 12.75 10 12.75L18 12.75C18.4142 12.75 18.75 12.4142 18.75 12C18.75 11.5858 18.4142 11.25 18 11.25L10 11.25ZM6 15.75C5.58579 15.75 5.25 16.0858 5.25 16.5L5.25 17L5.25 17.5C5.25 17.9142 5.58579 18.25 6 18.25L7 18.25C7.41421 18.25 7.75 17.9142 7.75 17.5L7.75 17L7.75 16.5C7.75 16.0858 7.41421 15.75 7 15.75L6 15.75ZM10 16.25C9.58579 16.25 9.25 16.5858 9.25 17C9.25 17.4142 9.58579 17.75 10 17.75L18 17.75C18.4142 17.75 18.75 17.4142 18.75 17C18.75 16.5858 18.4142 16.25 18 16.25L10 16.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H15C16.8613 22 17.7919 22 18.5451 21.7553C20.0673 21.2607 21.2607 20.0673 21.7553 18.5451C22 17.7919 22 16.8613 22 15V15V14.5M10 17L18 17M10 12L18 12M10 7H18M7 7V7C7 7.27614 6.77614 7.5 6.5 7.5V7.5C6.22386 7.5 6 7.27614 6 7V7M7 7V7C7 6.72386 6.77614 6.5 6.5 6.5V6.5C6.22386 6.5 6 6.72386 6 7V7M7 7H6M7 12V12C7 12.2761 6.77614 12.5 6.5 12.5V12.5C6.22386 12.5 6 12.2761 6 12V12M7 12V12C7 11.7239 6.77614 11.5 6.5 11.5V11.5C6.22386 11.5 6 11.7239 6 12V12M7 12H6M7 17V17C7 17.2761 6.77614 17.5 6.5 17.5V17.5C6.22386 17.5 6 17.2761 6 17V17M7 17V17C7 16.7239 6.77614 16.5 6.5 16.5V16.5C6.22386 16.5 6 16.7239 6 17V17M7 17H6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M10 17L18 17M10 12L18 12M10 7H18M7 7V7.5H6V7M7 7V6.5H6V7M7 7H6M7 12V12.5H6V12M7 12V11.5H6V12M7 12H6M7 17V17.5H6V17M7 17V16.5H6V17M7 17H6M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.25 6.5C5.25 6.08579 5.58579 5.75 6 5.75L7 5.75C7.41421 5.75 7.75 6.08579 7.75 6.5L7.75 7L7.75 7.5C7.75 7.91421 7.41421 8.25 7 8.25L6 8.25C5.58579 8.25 5.25 7.91421 5.25 7.5L5.25 7L5.25 6.5ZM9.25 7C9.25 6.58579 9.58579 6.25 10 6.25L18 6.25C18.4142 6.25 18.75 6.58579 18.75 7C18.75 7.41421 18.4142 7.75 18 7.75L10 7.75C9.58579 7.75 9.25 7.41421 9.25 7ZM5.25 11.5C5.25 11.0858 5.58579 10.75 6 10.75L7 10.75C7.41421 10.75 7.75 11.0858 7.75 11.5L7.75 12L7.75 12.5C7.75 12.9142 7.41421 13.25 7 13.25L6 13.25C5.58579 13.25 5.25 12.9142 5.25 12.5L5.25 12L5.25 11.5ZM9.25 12C9.25 11.5858 9.58579 11.25 10 11.25L18 11.25C18.4142 11.25 18.75 11.5858 18.75 12C18.75 12.4142 18.4142 12.75 18 12.75L10 12.75C9.58579 12.75 9.25 12.4142 9.25 12ZM5.25 16.5C5.25 16.0858 5.58579 15.75 6 15.75L7 15.75C7.41421 15.75 7.75 16.0858 7.75 16.5L7.75 17L7.75 17.5C7.75 17.9142 7.41421 18.25 7 18.25L6 18.25C5.58579 18.25 5.25 17.9142 5.25 17.5L5.25 17L5.25 16.5ZM9.25 17C9.25 16.5858 9.58579 16.25 10 16.25L18 16.25C18.4142 16.25 18.75 16.5858 18.75 17C18.75 17.4142 18.4142 17.75 18 17.75L10 17.75C9.58579 17.75 9.25 17.4142 9.25 17Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
